import { FC } from 'react'
import cn from 'classnames'
import TextareaAutosize from 'react-autosize-textarea'
import { useField } from 'formik-latest'

import { ReactComponent as IconAlert } from 'images/icons/alert.svg'

import styles from './TextArea.module.scss'

interface TextAreaProps {
  id: string
  name: string
  placeholder: string
  rows?: number
  maxLength: number
  className?: string
  onChange: (e: any) => void
}

const TextArea: FC<TextAreaProps> = ({ className = '', ...props }) => {
  const maxRows = 6
  const [field, meta] = useField(props)
  const hasError = meta.touched && meta.error
  const errorClass = hasError ? styles.error : ''
  return (
    <>
      <TextareaAutosize className={cn(className, errorClass)} maxRows={maxRows} {...field} {...props} />
      {hasError && (
        <div className={styles.errorMessage}>
          <IconAlert /> {meta.error}
        </div>
      )}
    </>
  )
}

export default TextArea
